import React from 'react';
import { Check, X } from 'lucide-react';
import { siteConfig } from '../config/siteConfig';
import { motion } from 'framer-motion';
export function WhoIsThisFor() {
  return <section className="w-full bg-brand-cream py-24 md:py-40" data-id="element-254">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-255">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-256">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-257">
            <h2 className="font-heading text-2xl md:text-[40px] font-bold text-brand-navy mb-10 whitespace-nowrap" data-id="element-258">
              This Is For You If
            </h2>
            <ul className="space-y-8" data-id="element-259">
              {siteConfig.fit.forYou.map((item, idx) => <li key={idx} className="flex items-start gap-5" data-id="element-260">
                  <div className="mt-1 flex-shrink-0 w-8 h-8 rounded-full bg-green-100 flex items-center justify-center" data-id="element-261">
                    <Check className="w-5 h-5 text-green-600" data-id="element-262" />
                  </div>
                  <span className="text-lg md:text-xl text-muted-foreground leading-relaxed font-light" data-id="element-263">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-264">
            <h2 className="font-heading text-2xl md:text-[40px] font-bold text-muted-foreground mb-10 whitespace-nowrap" data-id="element-265">
              This Is Not For You If
            </h2>
            <ul className="space-y-8" data-id="element-266">
              {siteConfig.fit.notForYou.map((item, idx) => <li key={idx} className="flex items-start gap-5" data-id="element-267">
                  <div className="mt-1 flex-shrink-0 w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-268">
                    <X className="w-5 h-5 text-red-400" data-id="element-269" />
                  </div>
                  <span className="text-lg md:text-xl text-muted-foreground leading-relaxed font-light" data-id="element-270">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}